<template>
  <el-upload
    class="import-deal"
    :action="host + source.url"
    :headers="headers"
    :data="getData()"
    :on-success="handleSuccess"
    :on-error="handleError"
    :file-list="fileList"
    style="display: none">
  </el-upload>
</template>

<script>
  import http from '../../../../assets/js/http'
  export default {
    props: {
      source: {
        type: Object,
        default() {
          return {
            url: ''
          }
        }
      },
      query: {
        type: String,
        default() {
          return ''
        }
      },
      isQueryGet: {
        type: Number,
        default() {
          return 0
        }
      }
    },
    data() {
      return {
        host: '',
        headers: {},
        fileList: []
      }
    },
    methods: {
      getData() {
        let data = {}
        if (this.isQueryGet) {
          // 需传参
          data = {
            query: this.query
          }
        }
        return data
      },
      openUpload() {
        document.querySelector('.import-deal input[name=file]').value = ''
        if (this.isQueryGet) {
          this.headers = _g.updateHttpHeader()
        } else {
          // 不需传参
          let base64 = window.btoa((new Date()).getTime())
          let token = Lockr.get('token') + '%' + base64
          this.headers = {
            token: token
          }
        }
        document.querySelector('.import-deal input[name=file]').click()
      },
      handleProgress(res, file, fileList) {
        this.$emit('setLoading', true)
      },
      handleSuccess(res, file, fileList) {
        this.$emit('setLoading', false)
        if (res.code == 200) {
          this.fileList = []
          this.$emit('importCallback', true, res)
        } else {
          this.fileList = []
          _g.dealError(this, res)
          this.$emit('importCallback', false)
        }
      },
      handleError(err, file, fileList) {
        this.$emit('setLoading', false)
        this.fileList = []
        this.$emit('importCallback', false)
      }
    },
    created() {
      this.host = HOST
    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// importDeal.vue?b744c3d0